export default __webpack_public_path__ + "static/media/companylogo.382cfee2.svg";